
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practices",
      function () {
        return require("private-next-pages/practices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practices"])
      });
    }
  